import { gql } from '@apollo/client';

export const GET_AI_CLIPPER_METRICS_SUMMARY = gql`
  query AiClipperMetricsSummary($filter: AiClipperMetricsFilterInput) {
    aiClipperMetricsSummary(filter: $filter) {
      totalGenerated
      accepted
      manualAccepted
      systemAccepted
      rejected
      notReviewed
      acceptRatePctOfReviewed
      sourceBreakdown {
        sourceType
        totalGenerated
        accepted
        manualAccepted
        systemAccepted
        rejected
        notReviewed
      }
    }
  }
`;

export const GET_AI_CLIPPER_USER_BREAKDOWN = gql`
  query AiClipperUserBreakdown($input: GetAiClipperUserBreakdownInput!) {
    aiClipperUserBreakdown(input: $input) {
      entities {
        userId
        userSlug
        userName
        candidatesGenerated
        accepted
        manualAccepted
        systemAccepted
        rejected
        pendingReview
      }
      total
      offset
      limit
    }
  }
`;

export const GET_AI_CLIPPER_TIME_SERIES = gql`
  query AiClipperTimeSeries($input: GetAiClipperTimeSeriesInput!) {
    aiClipperTimeSeries(input: $input) {
      points {
        bucketStart
        totalGenerated
        accepted
        manualAccepted
        systemAccepted
        rejected
        notReviewed
      }
      truncated
    }
  }
`;
